import { render, staticRenderFns } from "./DashboardStart.vue?vue&type=template&id=29c7dc90&lang=pug"
import script from "./DashboardStart.vue?vue&type=script&lang=js"
export * from "./DashboardStart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports